let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Gwzy")).then(() => parcelRequire('9ZuI1'));